import {getToken, isLoggedIn} from "./auth";
import i18next from "../i18next";
import environment from "../environment";

export type QidigoError = {
    message: string,
    status: number,
    messageTranslationKey?: string
}

export interface RequestAdditionalParams {
    onSuccess?: Function,
    onError?: (error: string) => void,
    goToRedirectUrl?: Function,
    search?:     string,
    redirectToLogin?: Function,
    redirectToRegisterWithCompletionState?: Function,
    redirectToGroups?: Function,
    organizationId?: number,
    session_uuid?: string
}
const localDomain = 'http://localhost:8081';
const prodDomain = 'https://api.qidigo.com';
const getApiUrl = (version: string) => process.env.NODE_ENV === 'development' ? localDomain + `/api/${version}` : prodDomain + `/api/${version}`;

export const qidigoFetch = async (resource: string, init: RequestInit, requestAdditionalParams: RequestAdditionalParams = {}, apiUrl: string = environment.REACT_APP_API_URL): Promise<any> => {

    const groupOffersRegex = new RegExp('^groups/[0-9]*/offers*');

    if (resource === 'whoami') {
        apiUrl = getApiUrl('v1');
    }

    if (resource === 'countries') {
        apiUrl = getApiUrl('v1');
    }

    const cartRegex = new RegExp('^cart/?[0-9]*');
    if (cartRegex.test(resource)) {
        apiUrl = getApiUrl('v1p1');
    }

    if (groupOffersRegex.test(resource)) {
        apiUrl = getApiUrl('v1');
    }

    const batchGroupOffersRegex = new RegExp('^batch-group-session-offers*');
    if (batchGroupOffersRegex.test(resource)) {
      apiUrl = getApiUrl('v1p1');
    }

    const groupRegex = new RegExp('^groups/[0-9]*$');
    if (groupRegex.test(resource)) {
        apiUrl = getApiUrl('v1');
    }

    const programmationGroupsRegex = new RegExp('^organizations/[0-9]*/programs/groups*');
    if (programmationGroupsRegex.test(resource)) {
        apiUrl = getApiUrl('v1');
    }

    const locationsRegex = new RegExp('^organizations/[0-9]*/iframe/locations*');
    if (locationsRegex.test(resource)) {
        apiUrl = getApiUrl('v1p1');
    }

    const facilityUnavailabilityRegex = new RegExp('^organizations/[0-9]*/iframe/locations/unavailabilities*');
    if (facilityUnavailabilityRegex.test(resource)) {
        apiUrl = getApiUrl('v1p1');
    }

    const organizationActivitiesRegex = new RegExp('^organizations/[0-9]*/activities*');
    if (organizationActivitiesRegex.test(resource)) {
        apiUrl = getApiUrl('v1p1');
    }

    const activitiesSessionsRegex = new RegExp('^activities/[0-9]*/sessions*');
    if (activitiesSessionsRegex.test(resource)) {
        apiUrl = getApiUrl('v1');
    }

    const activitiesGroupsRegex = new RegExp('^activities/[0-9]*/groups*');
    if (activitiesGroupsRegex.test(resource)) {
        apiUrl = getApiUrl('v1');
    }

    const membershipTemplateOffersRegex = new RegExp('^membership_templates/[0-9]*/offers*');
    if (membershipTemplateOffersRegex.test(resource)) {
        apiUrl = getApiUrl('v1');
    }

    const userWaitingListRegex = new RegExp('^users/[0-9]*/waiting_lists*');
    if (userWaitingListRegex.test(resource)) {
        apiUrl = getApiUrl('v1');
    }

    const userPhoneNumbersRegex = new RegExp('^users/[0-9]+/phone_numbers*');
    if (userPhoneNumbersRegex.test(resource)) {
        apiUrl = getApiUrl('v1');
    }

    const userAddressesRegex = new RegExp('^users/[0-9]+/addresses*');
    if (userAddressesRegex.test(resource)) {
        apiUrl = getApiUrl('v1');
    }

    const contactRegex = new RegExp('^contacts*');
    if (contactRegex.test(resource)) {
        apiUrl = getApiUrl('v1p1');
    }

    const organizationCssRegex = new RegExp('^organizations/[0-9]+/iframe/css');
    if (organizationCssRegex.test(resource)) {
        apiUrl = getApiUrl('v1p1');
    }
    
    const defaults = {
        headers: {
            "Accept": "application/json",
            "Accept-Language": i18next.language,
            "Content-Type": "application/json",
        },
        mode: "cors",
        credentials: 'include'
    };
    const resultingInit = Object.assign({}, defaults, init);
    resultingInit.headers = Object.assign({}, defaults.headers, init.headers);

    const response = await fetch(`${apiUrl}/${resource}`, resultingInit);
    if (response.ok) {
        if (!!requestAdditionalParams.onSuccess) requestAdditionalParams.onSuccess();
        if (response.status === 204 || response.status === 202) {
            return {};
        }
        return response.json();
    }
    else {
        let responseJson;
        try {
            responseJson = await response.json();
        }
        catch {}
        if (!!requestAdditionalParams.onError) requestAdditionalParams.onError(responseJson ? responseJson.message : undefined);
        // eslint-disable-next-line no-throw-literal
        else throw {status: response.status, message: responseJson ? responseJson.message : undefined};
    }
};

export const qidigoAuthenticatedFetch = async (resource: string, init: RequestInit, requestAdditionalParams: RequestAdditionalParams = {}, apiUrl: string = environment.REACT_APP_API_URL): Promise<any> => {
    const loggedIn = await isLoggedIn();
    if (!loggedIn && !!requestAdditionalParams.redirectToLogin) requestAdditionalParams.redirectToLogin();
    const resultingInit = Object.assign({}, init);
    const token = getToken();
    if (token) {
        resultingInit.headers = Object.assign({}, getTokenRequestHeaders(token), init.headers);
    }

    try {
        return await qidigoFetch(resource, resultingInit, requestAdditionalParams, apiUrl);
    } catch(e) {
        // if call is forbidden, redirect to login, else re-throw
        if (e.status === '403' && !!requestAdditionalParams.redirectToLogin) {
            requestAdditionalParams.redirectToLogin();
        }
        else throw e;
    }
};

export const getTokenRequestHeaders = (token: string) => {
    return {
        "Authorization": `Bearer ${token}`,
        "Bearer-Authorization": `Bearer ${token}`
    }
};
